import React, { useState, useEffect } from "react";
import { Col, FormGroup, Label } from "reactstrap";
import { SaveNetworkName, GetExternalHubURILink } from 'action/secureconnectAction';
import { useDispatch, useSelector } from "react-redux";
import { sendSingleAmplitudeEvent } from "amplitude/amplitude";
import { ManageSecureConnect, StyledForm, CorrectAllError, ErrorIcon, StyledHRColumn, SaveButton, CloseButton,
    HeaderLabelCol, ErrorLabel, ErrorContainer } from "./styled";
import { useGetLocalizationLabel } from "./useAPIMethods";

const AddSecureConnect = ({ 
        networkList,
        getNetworkList,
        onPopupCancel,
        parentSetState
    }) => {
    const dispatch = useDispatch();
    const externalHubUri = useSelector(state => state.HubManagementRootReducer.GetExternalHubUri);
    const [state, setState] = useState({
        isError: false,
        errorMessage: "",
        enteredNetworkName: "",
        errorOnSubmit: false
    });
    const { getLabel } = useGetLocalizationLabel();

    // **** For componentDidMount method ***** //
    useEffect(() => {
        dispatch(GetExternalHubURILink());
    }, []);

    // const allowOnlyTexts = (event) => {
    //     const regex = new RegExp("^[a-zA-Z ]+$");
    //     const inputValue = String.fromCharCode(event.keyCode || event.which);
    //     // allow letters and white spaces only.
    //     if (!regex.test(inputValue)) {
    //         event.preventDefault();
    //     }
    // }

    // const allowOnlyTextsNumbers = (event) => {
    //     const regex = new RegExp("^[a-zA-Z0-9 ]+$");
    //     const inputValue = String.fromCharCode(event.keyCode || event.which);
    //     // allow letters and white spaces only.
    //     if (!regex.test(inputValue)) {
    //         event.preventDefault();
    //     }
    // }

    // const allowOnlyNumbers = (event) => {
    //     const regex = new RegExp("^[0-9]*$");
    //     const inputValue = String.fromCharCode(event.keyCode || event.which);
    //     // allow numbers only.
    //     if (!regex.test(inputValue)) {
    //         event.preventDefault();
    //     }
    // }

    const saveNetworkCallBack = (status, errorDetails) => {
        if (status === "error") {
            parentSetState(prevState => ({ ...prevState, apiError: errorDetails.message, loading: false }));
        } else {
            parentSetState(prevState => ({ ...prevState, loading: false }));
            getNetworkList();
            onPopupCancel();
            sendSingleAmplitudeEvent("BACnet Secure Networks");
        }
    }

    const saveSecureConnect = () => {
        if (state.isError) {
            setState(prevState => ({ ...prevState, errorOnSubmit: true }));
        } else {
            const { enteredNetworkName } = state;
            const errorDetails = validateName(enteredNetworkName);
            if (errorDetails && errorDetails.isError) {
                setState(prevState => ({ ...prevState, ...errorDetails, errorOnSubmit: true }));
            } else {
                parentSetState(prevState => ({ ...prevState, loading: true }));
                setState(prevState => ({ ...prevState, ...errorDetails, errorOnSubmit: false }));
                const payLoad = {
                    "EndPointUrl": `${externalHubUri}/${enteredNetworkName}`,
                    "NetworkName": enteredNetworkName 
                }
                dispatch(SaveNetworkName(payLoad, saveNetworkCallBack));
            }
        }
    }

    const validateName = (name) => {
        let isDuplicateName = false;
        if(name && Array.isArray(networkList) && networkList.length) {
            const lstNetworks = JSON.parse(JSON.stringify(networkList));
            for (let i = 0; i < lstNetworks.length; i++) {
                if(lstNetworks[i] && lstNetworks[i].networkName && lstNetworks[i].networkName === name) {
                    isDuplicateName = true;
                    break;
                }
            }
        }
        if (isDuplicateName) {
            return {
                errorMessage: getLabel("DublicateName") ? getLabel("DublicateName") : "Name already exist",
                isError: true
            };
        } else if (!name) {
            return {
                errorMessage: getLabel("EntryRequired") ? getLabel("EntryRequired") : "An entry is required",
                isError: true
            };
        } else {
            return {
                errorMessage: "",
                isError: false
            };
        }
    }

    const onChangeNetworkName = (name) => {
        const regex = new RegExp(/^[A-Za-z][a-zA-Z0-9-]*$/);
        const regexAlp = new RegExp(/[A-Za-z]/i); // To validate name should start with an alphabet
        if (name && (!regex.test(name) || !regexAlp.test(name))) {
            setState(prevState => ({ ...prevState,
                errorMessage: !regexAlp.test(name) ? 
                    "Network name should start with an alphabet, it can contain alphanumeric characters or -" : "Network name should not contain any special characters or space except -",
                isError: true }));
        } else {
            const errorValidation = validateName(name);
            setState(prevState => ({ ...prevState, ...errorValidation, enteredNetworkName: name, errorOnSubmit: false }));
        }
    }

    return (<ManageSecureConnect>
            {
                state.errorOnSubmit ? <CorrectAllError>
                    <ErrorIcon /><b>{ getLabel("CorrectAllError") ? getLabel("CorrectAllError") : "Please correct all errors before continuing." }</b>
                </CorrectAllError> : null
            }
            <StyledForm>
                <FormGroup row>
                    <HeaderLabelCol sm={{ size: 12 }}>
                        <Label>{ getLabel("CreateSecureNetworkTitle") ? getLabel("CreateSecureNetworkTitle") : "Create Secure Connect BACnet Network" }</Label>
                    </HeaderLabelCol>
                </FormGroup>
                <FormGroup row >
                    <StyledHRColumn sm={{ size: 12 }}>
                        <hr />
                    </StyledHRColumn>
                </FormGroup>
                <FormGroup row >
                    <Col sm={{ size: 3 }}>
                        <Label className={state.isError ? "errortext workorderlbl CreatePMlbl_margin" : "workorderlbl CreatePMlbl_margin"}>
                            { getLabel("Name") ? getLabel("Name") : "Name" }
                            </Label><br />
                    </Col>
                    <Col sm={{ size: 8 }}>
                        <input 
                            type="text"
                            maxLength="200"
                            id="network-name"
                            className={state.isError ? "errorhighlight pm_textbox" : "pm_textbox"}
                            defaultValue={state.enteredNetworkName}
                            onChange={(event)=>onChangeNetworkName(event.target.value)}
                        />
                        <ErrorContainer hidden={!state.isError}>
                            <ErrorIcon fontSize="15px"/>
                            <ErrorLabel>
                                {state.errorMessage}
                            </ErrorLabel>
                        </ErrorContainer>
                    </Col>
                </FormGroup>
                <FormGroup row >
                    <Col sm={{ size: 3 }}>
                        <Label className="workorderlbl CreatePMlbl_margin">{ getLabel("Endpoint") ? getLabel("Endpoint") : "Endpoint" }</Label>
                        <br />
                    </Col>
                    <Col sm={{ size: 8 }}>
                        <Label>{typeof externalHubUri === "string" ? `${externalHubUri}/${state.enteredNetworkName}` : "--"}</Label>
                    </Col>
                </FormGroup>
                <FormGroup row >  
                    <Col sm={{ size: 9 }}>
                        <CloseButton mr="0" ml="15px" onClick={onPopupCancel}>{ getLabel("Close") ? getLabel("Close") : "Close" }</CloseButton>
                        <SaveButton primary onClick={saveSecureConnect}>{ getLabel("Save") ? getLabel("Save") : "Save" }</SaveButton>
                    </Col>  
                </FormGroup>
            </StyledForm>
        </ManageSecureConnect>);
};

export default AddSecureConnect;